import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Layout from "./layout";
import useGlobalStyles from "./styles/globalStyles";
import { useDispatch, useSelector } from "react-redux";
import { selectGlobalState } from "./state-management/selectors";
import importAllPages from "./utils/import-all-pages";
import LoginPage from "./pages/login-page";
import ForgotPassword from "./pages/forgot-password";
import { SidebarItem } from "./types/sidebar";
import Sidebar from "./components/sidebar/sidebar";
import { SidebarData } from "./components/sidebar/sidebar-data";
import { useEffect, useMemo } from "react";
import { getRoles } from "./state-management/actions/role-actions";
import { setRolesData } from "./state-management/actions/global-state-actions";
const pages = importAllPages(
  require.context("./pages", true, /\.(tsx|jsx|ts|js)$/)
);

function App() {
  const dispatch = useDispatch();

  useGlobalStyles();
  const { isLogined, currentUserData, rolesData } =
    useSelector(selectGlobalState);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getRoles()(dispatch);
      if (response.status === 200) {
        dispatch(setRolesData(response.data));
      }
    };
    if (rolesData.length === 0) {
      fetchData();
    }
  }, [dispatch, rolesData]);

  const permissionsPages = useMemo(() => {
    if (rolesData && currentUserData?.role_id) {
      const role = rolesData.find(
        (item: any) => item._id === currentUserData.role_id
      );
      return role?.permissions || [];
    }
    return [];
  }, [rolesData, currentUserData]);

  const renderRoute = (page: any, PageComponent: any) => {
    return (
      <Route
        key={page}
        path={`/${page}`}
        element={
          <>
            <PageComponent />
            <Sidebar data={SidebarData as SidebarItem[]} />
          </>
        }
      />
    );
  };

  if (!rolesData || rolesData.length === 0) {
    return <></>;
  }

  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          {Object.keys(pages).map((page) => {
            const PageComponent = pages[page];
            if (isLogined && permissionsPages.includes(`/${page}`)) {
              return renderRoute(page, PageComponent);
            }
            return null;
          })}
          {!isLogined && (
            <>
              <Route path="/login-page" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
            </>
          )}
          <Route
            path="/*"
            element={
              <Navigate
                to={isLogined ? "/dashboard-page" : "/login-page"}
                replace
              />
            }
          />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
